export const CSS_CLASSES = {
	WIDGET: 'widget--notification-table',
	WIDGET_EMPTY: 'widget--notification-table__card--empty',
	WIDGET_REFRESHING: 'widget--notification-table--refreshing',
};

/**
 * Maximum number of rows to render per notification type.
 * @type {Number}
 */
export const MAX_DRAWERS = 10;
